export default __webpack_public_path__ + "static/media/customization_2.e6a13b30.webp";